import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";


export default function Dashboard({ setToken }) {
  const navigate = useNavigate();


  const POWERBI_EMBED_URL =
    "https://app.powerbi.com/view?.....................";

  const titlePillStyle = useMemo(
    () => ({ background: "linear-gradient(90deg, #00b3b3, #00e68a)" }),
    []
  );

  const handleLogout = () => {
    localStorage.removeItem("token");
    setToken(null);
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen bg-[#231f2b] text-white font-nexa font-normal">
      <Navbar />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-14 space-y-10">
        {/* Header */}
        <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
          <div className="flex justify-start">
            <div
              className="inline-block text-[#231f2b] font-extrabold text-2xl md:text-3xl px-8 py-4 rounded-2xl shadow-lg"
              style={titlePillStyle}
            >
              Inteligencia en Movimiento
            </div>
          </div>

          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate("/marcas")}
              className="bg-[#2c2833] border border-white/10 text-gray-200 px-5 py-3 rounded-xl hover:scale-105 transition-transform"
            >
              Acceso Premium
            </button>

            <button
              onClick={handleLogout}
              className="bg-gradient-to-r from-[#00b3b3] to-[#00e68a] text-[#231f2b] font-semibold px-6 py-3 rounded-xl hover:scale-105 transition-transform"
            >
              Cerrar sesión
            </button>
          </div>
        </div>

        {/* Reporte Power BI */}
        <div className="bg-[#2c2833] rounded-2xl shadow-lg border border-white/10 overflow-hidden">
          <div className="p-6 md:p-8 border-b border-white/10">
            <h2 className="text-xl md:text-2xl font-semibold text-[#00e68a]">
             Mercado Mayorista y Minorista
            </h2>
            <p className="text-gray-300">
              Visualización integrada directamente desde Power BI.
            </p>
          </div>

          <div className="p-3 md:p-4">
            <div className="relative w-full overflow-hidden rounded-2xl border border-white/10 bg-black/20">
              {/* ✅ 16:9 responsive */}
              <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
                <iframe
                  title="PowerBI Report"
                  src={POWERBI_EMBED_URL}
                  className="absolute inset-0 w-full h-full"
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
            </div>

            <p className="mt-3 px-2 text-xs text-gray-400">
              Si no carga: revisa permisos o usa “Publish to web”.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
